import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=5724c4b1&scoped=true&"
import script from "./editQuestion.vue?vue&type=script&lang=ts&"
export * from "./editQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=5724c4b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724c4b1",
  null
  
)

export default component.exports